import "bootstrap/dist/css/bootstrap.css"
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createStore } from 'vuex'
import vue3GoogleLogin from 'vue3-google-login'
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

const store = createStore({
    state() {
        return {
            token: "",
            cart_items: [],
            currency: "",
            country: "",
            southeastAsia: ["MY", "PH", "SG", "TH", "BN", "MM", "KH", "VN", "IN", "PK", "LA", "BD", "MN", "PK", "LK", "NP", "BT"],
            countryFlag: 0,
            products: [],
            checkouts: [],
            hotel:"",
            intlProductId:"987244f3-5223-472f-8721-50be92788bde",
            baseUrl: "https://backend-prod-4qnq.onrender.com",
        }
    },
    mutations: {
        addCheckouts(state, name){
            state.checkouts.push(name)
        },
        changeToken(state, newToken) {
            state.token = newToken;
        },
        changeHotel(state, hotel) {
            state.hotel = hotel;
        },
        changeIntlProductId(state, id) {
            state.intlProductId = id;
        },
        changeCountryFlag(state, newFlag) {
            state.countryFlag = newFlag;
        },
        changeCountry(state, newCountry) {
            state.country = newCountry;
        },
        changeCurrency(state, newCurrency){
            state.currency = newCurrency;
        },
        addProduct(state, newProduct) {
            state.cart_items.push(newProduct)
        },
        removeProduct(state, deletedProduct) {
            let indexToBeDeleted = -1
            state.cart_items.forEach(element => {
                if(element == deletedProduct){
                    indexToBeDeleted = state.cart_items.indexOf(element)
                }
            });
            state.cart_items.splice(indexToBeDeleted, 1);
        },
        replaceProducts(state, newProductList){
            state.products = newProductList
        }
    }
})

createApp(App)
    .use(store)
    .use(router)
    .use(vue3GoogleLogin, {
        clientId: '28333275363-he9qftutpqbtt7vpnsdkeocp80jl0a35.apps.googleusercontent.com'
        })
    .mount('#app')

import "bootstrap/dist/js/bootstrap.js"
